/* import __COLOCATED_TEMPLATE__ from './mixed-use-select-shared-settings-type.hbs.js'; */
var _dec, _class, _descriptor;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { action } from '@ember/object';
import { readOnly } from '@ember/object/computed';
import Component from '@ember/component';
import { Vertical } from '@dashboard/shared-ui/utils/vertical-configs';

/**

## Modals::MixedUseSelectSharedSettingsType

When a user has permission to create multiple types of shared settings,
this modal shows when they click "Create Shared Settings".

@param {boolean} [modalOptions.canUseRestaurantsMobile] If enabled shows Restaurants Mobile shared setting choice.
@param {Action} [close] Closes the modal (via the Modal Service)
*/
let MixedUseSelectSharedSettingsType = (_dec = readOnly('modalOptions.canUseRestaurantsMobile'), _class = class MixedUseSelectSharedSettingsType extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "canUseRestaurantsMobile", _descriptor, this);
  }
  selectRestaurants() {
    this.close({
      didContinue: true,
      vertical: Vertical.RESTAURANTS
    });
  }
  selectRestaurantsMobile() {
    this.close({
      didContinue: true,
      vertical: Vertical.RESTAURANTS_MOBILE
    });
  }
  selectRetail() {
    this.close({
      didContinue: true,
      vertical: Vertical.RETAIL
    });
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "canUseRestaurantsMobile", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "selectRestaurants", [action], Object.getOwnPropertyDescriptor(_class.prototype, "selectRestaurants"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "selectRestaurantsMobile", [action], Object.getOwnPropertyDescriptor(_class.prototype, "selectRestaurantsMobile"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "selectRetail", [action], Object.getOwnPropertyDescriptor(_class.prototype, "selectRetail"), _class.prototype), _class);
export { MixedUseSelectSharedSettingsType as default };